import { AuthReturn } from '@/modules/Auth/apiTypes/base'

export enum TokenKeys {
  Auth = 'EMT/Auth/AuthToken',
  Refresh = 'EMT/Auth/RefreshToken',
  Mercure = 'EMT/Auth/MercureToken',
  MercureUrl = 'EMT/Auth/MercureUrl',
}

/* ***********************
 * LOCAL STORAGE SHORTCUTS
 * *********************** */

export const _saveItem = (itemKey: string, selectedValue: string) => {
  localStorage.setItem(itemKey, selectedValue)
}

export const _getItem = (itemKey: string) =>
  typeof localStorage !== 'undefined' ? localStorage.getItem(itemKey) : undefined

export const _removeItem = (itemKey: string) => {
  localStorage.removeItem(itemKey)
}

/**
 * Helper function to save auth info in localStorage
 * @param infos
 * @returns
 */
export const _saveAuthInfo = (infos: AuthReturn): void => {
  const { token, refreshToken, mercureToken, mercurePublishUrl } = infos
  _saveItem(TokenKeys.Auth, token)
  _saveItem(TokenKeys.Refresh, refreshToken)
  if (mercureToken) {
    _saveItem(TokenKeys.Mercure, mercureToken)
  }
  if (mercurePublishUrl) {
    _saveItem(TokenKeys.MercureUrl, mercurePublishUrl)
  }
}
